<div class="container">
  <div *ngIf="offer" class="box mb-3">
    <img [src]="getPictureUrl(offer)" />
    <div class="content">
      <div class="title h4">{{ offer.title }}</div>
      <div class="description">Jusqu'au {{ offer.end|date:'dd/MM/y' }}</div>
    </div>
  </div>
  <div class="description" [innerHTML]="offer.description"></div>
</div>